import axios from 'axios';
import { CMError } from "./cm-error.model";
import Vue from "vue";

Vue.mixin({
    beforeCreate() {
        const options = this.$options;
        if (options.ReservationAPI)
            this.$reservationApi = options.ReservationAPI;
        else if (options.parent && options.parent.$reservationApi)
            this.$reservationApi = options.parent.$reservationApi;
    }
});

export function makeReservationAPI(token, conf) {
    return new ReservationAPI(token, conf);
}

export default class ReservationAPI {

    constructor(token) {
        this._ax = axios.create({
            baseURL: process.env.VUE_APP_RESERVATION_API_ENDPOINT || '//reservation.codemotion.com/public/api/',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token,
            }
        });
    }

    async reservationsList(type, upcoming, page, perPage) {
        try {
            const res = await this._ax.post(`reservation/me/search?page=${page}&per_page=${perPage}`, {
                type: type,
                upcoming: upcoming,
            });
            return res.data.data;
        } catch (error) {
            this._handleError(error);
        }
    }

    async checkinList(meetupId) {
        try {
            const res = await this._ax.get(`reservation/byeid/${meetupId}/attendees`);
            return res.data.data.attendees;
        } catch (error) {
            this._handleError(error);
        }
    }

    _handleError(error) {
        if (error.response) {
            if (error.response.status === 401) {
                throw new CMError('Unauthorized', error);
            }
            if (error.response.status === 409) {
                throw new CMError('Conflict', "There is another event with the same data");
            }
            throw new CMError("GenericError", error.response)
        } else if (error.request) {
            throw new Error('Error on request => Server does not respond');
        } else {
            throw new Error('Client error => ' + error.message);
        }
    }
}